<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="ma-3">
        <v-card-text>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 sm2 xl1>
              <v-subheader class="mt-2">Desde</v-subheader>
            </v-flex>
            <v-flex xs10 sm4>
              <v-dialog
                v-model="startDateDialog"
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Fecha"
                    v-model="startDate"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="es-co"
                  v-model="startDate"
                  :min="allowedStartDates.min"
                  :max="allowedStartDates.max"
                  scrollable
                  autosave
                />
              </v-dialog>
            </v-flex>
            <v-flex xs10 sm5 offset-sm1>
              <v-dialog
                v-model="startTimeDialog"
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    slot="activator"
                    label="Hora"
                    v-model="startTime"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="startTime" autosave/>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 sm2 xl1>
              <v-subheader class="mt-2">Hasta</v-subheader>
            </v-flex>
            <v-flex xs10 sm4>
              <v-dialog
                v-model="finishDateDialog"
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Fecha"
                    v-model="finishDate"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="es-co"
                  v-model="finishDate"
                  :min="allowedFinishDates.min"
                  :max="allowedFinishDates.max"
                  scrollable
                  autosave
                />
              </v-dialog>
            </v-flex>
            <v-flex xs10 sm5 offset-sm1>
              <v-dialog
                v-model="finishTimeDialog"
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Hora"
                    v-model="finishTime"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="finishTime" autosave/>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  name: 'custom-range',
  data: function () {
    return {
      startDate: null,
      startTime: null,
      startDateDialog: false,
      startTimeDialog: false,
      finishDate: null,
      finishTime: null,
      finishDateDialog: false,
      finishTimeDialog: false
    }
  },
  computed: {
    allowedStartDates: function () {
      const min = moment().subtract(6, 'months').toDate().toISOString().substr(0, 10)
      const max = moment().toDate().toISOString().substr(0, 10)
      return { min, max }
    },
    allowedFinishDates: function () {
      const startDateAndTime = this.startDateAndTime
      if (!this.startDateAndTime) {
        return { min: null, max: null }
      }
      const thisMonth = moment().month()
      const min = startDateAndTime.toDate().toISOString().substr(0, 10)
      let max
      if (startDateAndTime.month() === thisMonth) {
        max = moment().toDate().toISOString().substr(0, 10)
      } else {
        max = startDateAndTime.endOf('month').toDate().toISOString().substr(0, 10)
      }
      return { min, max }
    },
    startDateAndTime: function () {
      if (!this.startDate || !this.startTime) {
        return null
      }
      return moment(`${this.startDate} ${this.startTime}`, 'YYYY-MM-DD h:mmA')
    },
    finishDateAndTime: function () {
      if (!this.finishDate || !this.finishTime) {
        return null
      }
      return moment(`${this.finishDate} ${this.finishTime}`, 'YYYY-MM-DD h:mmA')
    }
  },
  watch: {
    startDate: function () {
      this.finishDate = null
      this.$emit('update-finish-date', null)
      this.getStartDateAndTime()
    },
    startTime: function () {
      this.getStartDateAndTime()
    },
    finishDate: function () {
      this.getFinishDateAndTime()
    },
    finishTime: function () {
      this.getFinishDateAndTime()
    }
  },
  methods: {
    getStartDateAndTime: function () {
      const startDateAndTime = this.startDateAndTime
      if (!startDateAndTime) {
        this.$emit('update-start-date', null)
      } else {
        this.$emit('update-start-date', startDateAndTime.valueOf())
      }
    },
    getFinishDateAndTime: function () {
      const finishDateAndTime = this.finishDateAndTime
      if (!finishDateAndTime) {
        this.$emit('update-finish-date', null)
      } else {
        this.$emit('update-finish-date', finishDateAndTime.valueOf())
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/CustomRange.vue